import { render, staticRenderFns } from "./TgHeader.vue?vue&type=template&id=2cfcfe06"
import script from "./TgHeader.vue?vue&type=script&lang=js"
export * from "./TgHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports